import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { ApprovalReportPage } from '@/features/marketPromotion/pages/ApprovalReportPage';
import { approvalReportSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/approval-report')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.APPROVAL_REPORT_VIEW),
  validateSearch: approvalReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Approval Report">
      <Suspense fallback={<PageLoader />}>
        <ApprovalReportPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
